export default __webpack_public_path__ + "static/media/program_2.b214540b.png";